import { MUX_VIDEO_URL_BASE } from '../configuration';
import { ReactionType } from '@/api/model/activity';


/**
 * Builds a class list with each specified class name separated by a space. This is 
 * intended to be used like this:
 * @example 
 * <MyComponent className={classes('container', 'another-class', 'a-third-class')} />
 * 
 * @param first The first class to apply
 * @param more  Additional optional classes to apply
 * @returns The class list as a string suitable for passing in the className attribute.
 */
export const classes = (...more: Array<string | undefined>) => {
    const classList: string[] = [];
    if (more) {
        more.map((val) => {
            if (val) {
                classList.push(val);
            }
        });
    }
    return classList.join(' ');
}

/**
 * Builds a URL to a Mux video's poster image.
 * @param playbackId The Mux playback ID for the video.
 * @returns 
 */
export const videoPosterAddress = (playbackId: string): string => {
    return `${MUX_VIDEO_URL_BASE}${playbackId}/thumbnail.jpg`;
}


export const toTitleCase = (str: string): string => {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

export const reactionEmoji = (reaction: ReactionType): string => {
    switch (reaction) {
        case ReactionType.APPLAUSE:
            return "👏"
        case ReactionType.LOVE:
            return "❤️";
        case ReactionType.LIKE:
            return "👍";
        case ReactionType.DISLIKE:
            return "👎";
        case ReactionType.GRATEFUL:
            return "🙏";
        case ReactionType.HAPPY:
            return "😀";
        case ReactionType.LAUGH:
            return "😂";
        case ReactionType.SURPRISE:
            return "😲";
    }
    return "";
}
